var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Cant. Sellos")]),
          _vm._v(" "),
          _c("th", [_vm._v("# Caja")]),
          _vm._v(" "),
          _c("th", [_vm._v("Serie de Caja")]),
          _vm._v(" "),
          _c("th", [_vm._v("Serie inicial")]),
          _vm._v(" "),
          _c("th", [_vm._v("Serie final")]),
          _vm._v(" "),
          _c("th", [_vm._v("Comentario")]),
          _vm._v(" "),
          _c("th", [_vm._v("Cant. Cajas")]),
          _vm._v(" "),
          _c("th", [_vm._v("Semana")]),
          _vm._v(" "),
          _c("th", [_vm._v("Patio de origen")]),
          _vm._v(" "),
          _c("th", [_vm._v("Patio de destino")]),
          _vm._v(" "),
          _c("th", [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.agregar }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.parametros, function(sello, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique una cantidad...",
                        id: "cant_sellos" + index,
                        name: "cant_sellos[]"
                      },
                      model: {
                        value: sello.cant_sellos,
                        callback: function($$v) {
                          _vm.$set(sello, "cant_sellos", $$v)
                        },
                        expression: "sello.cant_sellos"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique una cantidad...",
                        id: "caja_numero" + index,
                        name: "caja_numero[]"
                      },
                      model: {
                        value: sello.caja_numero,
                        callback: function($$v) {
                          _vm.$set(sello, "caja_numero", $$v)
                        },
                        expression: "sello.caja_numero"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "text",
                        "input-out": "",
                        placeholder: "Indique una serie de caja...",
                        id: "serie_caja" + index,
                        name: "serie_caja[]"
                      },
                      model: {
                        value: sello.serie_caja,
                        callback: function($$v) {
                          _vm.$set(sello, "serie_caja", $$v)
                        },
                        expression: "sello.serie_caja"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique una serie inicial...",
                        id: "serie_ini" + index,
                        name: "serie_ini[]"
                      },
                      model: {
                        value: sello.serie_ini,
                        callback: function($$v) {
                          _vm.$set(sello, "serie_ini", $$v)
                        },
                        expression: "sello.serie_ini"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique una serie final...",
                        id: "serie_fin" + index,
                        name: "serie_fin[]"
                      },
                      model: {
                        value: sello.serie_fin,
                        callback: function($$v) {
                          _vm.$set(sello, "serie_fin", $$v)
                        },
                        expression: "sello.serie_fin"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "text",
                        "input-out": "",
                        placeholder: "Indique un comentario...",
                        id: "comentario" + index,
                        name: "comentario[]"
                      },
                      model: {
                        value: sello.comentario,
                        callback: function($$v) {
                          _vm.$set(sello, "comentario", $$v)
                        },
                        expression: "sello.comentario"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique una cantidad de cajas...",
                        id: "cant_cajas" + index,
                        name: "cant_cajas[]"
                      },
                      model: {
                        value: sello.cant_cajas,
                        callback: function($$v) {
                          _vm.$set(sello, "cant_cajas", $$v)
                        },
                        expression: "sello.cant_cajas"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "number",
                        "input-out": "",
                        placeholder: "Indique el número de semanas...",
                        id: "semana" + index,
                        name: "semana[]"
                      },
                      model: {
                        value: sello.semana,
                        callback: function($$v) {
                          _vm.$set(sello, "semana", $$v)
                        },
                        expression: "sello.semana"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: sello.patio_origen,
                            expression: "sello.patio_origen"
                          }
                        ],
                        attrs: {
                          name: "patio_origen[]",
                          id: "patio_origen" + index
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              sello,
                              "patio_origen",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Seleccione...")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.patios, function(patio) {
                          return _c(
                            "option",
                            {
                              key: patio.code,
                              domProps: { value: patio.code }
                            },
                            [
                              _vm._v(
                                "\n                                    (" +
                                  _vm._s(patio.code) +
                                  ") " +
                                  _vm._s(patio.address) +
                                  "\n                                "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: sello.patio_destino,
                            expression: "sello.patio_destino"
                          }
                        ],
                        attrs: {
                          name: "patio_destino[]",
                          id: "patio_destino" + index
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              sello,
                              "patio_destino",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Seleccione...")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.patios, function(patio) {
                          return _c(
                            "option",
                            {
                              key: patio.code,
                              domProps: { value: patio.code }
                            },
                            [
                              _vm._v(
                                "\n                                    (" +
                                  _vm._s(patio.code) +
                                  ") " +
                                  _vm._s(patio.address) +
                                  "\n                                "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.parametros.length === 0,
                  expression: "parametros.length === 0"
                }
              ]
            },
            [_vm._m(0)]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "11" } }, [
      _c("strong", [_vm._v("No se ha agregado configuraciones de sellos.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8e7fc3e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8e7fc3e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/TablaSellos.vue
// module id = 463
// module chunks = 0